export default __webpack_public_path__ + "TUBE-RIGHT.jpg";